import React, { useEffect, useState } from "react";
import { HighlightedOverlay } from "../MessagePanel.style";

interface MessageHighlightOverlayProps {
  shouldFocusOnMessage?: boolean;
  shouldSelectMessage?: boolean;
}

const MessageHighlightOverlay = ({
  shouldFocusOnMessage = false,
  shouldSelectMessage = false,
}: MessageHighlightOverlayProps) => {
  const [isFocusedReply, setIsFocusedReply] =
    useState<boolean>(shouldFocusOnMessage);
  const [isHighlightMessage, setIsHighlightMessage] =
    useState<boolean>(shouldSelectMessage);
  useEffect(() => {
    if (shouldFocusOnMessage) {
      setIsFocusedReply(true);
      setTimeout(() => {
        setIsFocusedReply(false);
      }, 1500);
    }
  }, [shouldFocusOnMessage]);

  useEffect(() => {
    if (shouldSelectMessage) {
      setIsHighlightMessage(true);
    } else {
      setIsHighlightMessage(false);
    }
  }, [shouldSelectMessage]);

  return (
    (isFocusedReply || isHighlightMessage) && (
      <HighlightedOverlay data-testid="message-highlight-overlay" />
    )
  );
};

export default MessageHighlightOverlay;
